import { SilentRequest } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { getKenectLocations, KenectIntegration } from "../../data/kenect";

const TableStyled = styled("table")({
  textAlign: "left",
  width: "stretch",
  minWidth: "40em",
});

const TableHeadStyled = styled("thead")({
  fontSize: "18",
  fontWeight: "bold",
  borderBottom: "1px solid #222",
});

const KenectPage = () => {
  const [activeIntegrations, SetIntegrations] = useState<KenectIntegration[]>(
    []
  );
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    const retrieveIntegrations = async () => {
      if (isAuthenticated) {
        const account = instance.getAllAccounts()[0];
        const silentRequest: SilentRequest = {
          scopes: ["api://a22e7296-106f-4a00-af8d-f86edb386a1b/api_access"],
          account: account,
        };

        const token = await instance.acquireTokenSilent(silentRequest);
        const locations: KenectIntegration[] = await getKenectLocations(
          token.accessToken
        );
        SetIntegrations(locations);
      }
    };

    retrieveIntegrations();
  }, [isAuthenticated, instance]);

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          margin: "10px",
          padding: "15px",
          backgroundColor: "#f8f9fa",
          minWidth: "40em",
        }}
      >
        {isAuthenticated ? (
          <TableStyled>
            <TableHeadStyled>
              <tr>
                <td>Location Id</td>
                <td>Dealership</td>
                <td>Address</td>
                <td>City</td>
                <td>State</td>
              </tr>
            </TableHeadStyled>
            <tbody>
              {activeIntegrations
                .sort((a, b) => {
                  if (a.locationName < b.locationName) return -1;
                  if (a.locationName > b.locationName) return 1;
                  return 0;
                })
                .map((integration, index) => (
                  <tr key={index}>
                    <td>{integration.partnerLocationId}</td>
                    <td>{integration.locationName}</td>
                    <td>{integration.address}</td>
                    <td>{integration.city}</td>
                    <td>{integration.state}</td>
                  </tr>
                ))}
            </tbody>
          </TableStyled>
        ) : (
          <h5>Login to use the application</h5>
        )}
      </div>
    </>
  );
};
export default KenectPage;
